import PropTypes from 'prop-types';
import { Error, Typography } from '@figure/frontlib-gui';
import { LI, UL } from 'shared/components/List';
import { Instruction, InstructionButtonGroup } from './';

const PaystubInstruction = ({ handleBack, handleClick, serverError }) => (
  <Instruction space="1.6rem">
    <Typography.BodyBold semanticElement="h2">What you’ll need:</Typography.BodyBold>
    <UL resetMargin={false}>
      <LI>
        The name of your payroll provider (e.g. ADP). You can review our authorized payroll providers by selecting the "Link paystub"
        option below.
      </LI>
      <LI>Login credentials for your payroll provider’s online account</LI>
      <LI>At least one paystub dated within the last 5 weeks</LI>
    </UL>

    <Error display="block">{serverError}</Error>

    <InstructionButtonGroup buttonText="Link paystub" handleBack={handleBack} handleClick={handleClick} />
  </Instruction>
);

PaystubInstruction.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  serverError: PropTypes.string.isRequired,
};

export default PaystubInstruction;
